const formData: Record<string, string> = {
    search: 'search',
    from: 'date_init',
    to: "date_end",
    fileType: "file_type",
    percentage: "range_size",
    user: "user_ids",
    area: "areas_ids",
    department: "departments_ids",
    status: "status_ids",
}

const formatFilter = {
    createYear: "year",
    from: "start_date",
    to: "end_date",
    areas: "areas_ids",
    departments: "departments_ids",
    actionPlanType: "action_plan_by_item"
}

export { formData, formatFilter }